export { default } from './P2Text';
